export default abstract class Base64Support {
  abstract encode(value: string): string;
  abstract decode(value: string): string;
}
